import { SET_BREADCRUMB_MAPPER } from '../types/breadCrumbMapperConstants'

const initialState = {
  breadCrumbMapper: []
}

export default function breadCrumbReducer(state = initialState, action) {
  switch (action.type) {
    case SET_BREADCRUMB_MAPPER:
      return {
        ...state,
        breadCrumbMapper: action.payload ? action.payload : []
      }
    default:
      return state
  }
}
